/* eslint-disable @typescript-eslint/no-unused-vars */
export const noop = (...args: any[]) => {
  // Intentionally empty - this function does nothing
  return undefined;
};
